import { normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "date" }
const _hoisted_2 = { class: "title" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "container",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.open(`/blog/${_ctx.article.id}`)))
  }, [
    _createElementVNode("div", {
      class: "image",
      style: _normalizeStyle({ backgroundImage: `url(${_ctx.article.img})` })
    }, null, 4),
    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.article.date), 1),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.article.title), 1)
  ]))
}